import get from 'lodash/get'

import {
  baseRequest,
  fetchCollection
} from './index'

import { subLocationSchema } from '../schemas'

export const LOCATION_SUB_LOCATIONS_REQUEST = 'LOCATION_SUB_LOCATIONS_REQUEST'
export const LOCATION_SUB_LOCATIONS_SUCCESS = 'LOCATION_SUB_LOCATIONS_SUCCESS'
export const LOCATION_SUB_LOCATIONS_FAILURE = 'LOCATION_SUB_LOCATIONS_FAILURE'

function fetchSubLocationsByLocation (url, locationId, reload) {
  return fetchCollection({
    url,
    key: 'subLocations',
    schema: subLocationSchema,
    actions: [ LOCATION_SUB_LOCATIONS_REQUEST, LOCATION_SUB_LOCATIONS_SUCCESS, LOCATION_SUB_LOCATIONS_FAILURE ],
    responseInterceptor: (response) => ({ ...response, locationId, reload })
  })
}

export function loadSubLocationsByLocation (locationId, nextPage) {
  return (dispatch, getState) => {
    let {
      nextPageUrl
    } = get(getState(), `pagination.subLocationsByLocation.${locationId}`, {})

    if (!nextPage) {
      nextPageUrl = `/locations/${locationId}/sub_locations`
    }

    return dispatch(fetchSubLocationsByLocation(nextPageUrl, locationId, !nextPage))
  }
}

export const USER_SUB_LOCATIONS_REQUEST = 'USER_SUB_LOCATIONS_REQUEST'
export const USER_SUB_LOCATIONS_SUCCESS = 'USER_SUB_LOCATIONS_SUCCESS'
export const USER_SUB_LOCATIONS_FAILURE = 'USER_SUB_LOCATIONS_FAILURE'

export function fetchSubLocationsForUser () {
  return fetchCollection({
    url: '/sub_locations/for_user',
    key: 'subLocations',
    schema: subLocationSchema,
    actions: [
      USER_SUB_LOCATIONS_REQUEST,
      USER_SUB_LOCATIONS_SUCCESS,
      USER_SUB_LOCATIONS_FAILURE
    ],
  })
}



// WEBPACK FOOTER //
// ./src/actions/sub-locations.js